interface ToolTipProps {
    ToolTipItem: string;
    top?: string;
    width?: string;
    left?: string;
    bgColor?: string;
    textColor?: string;
}
export default function ToolTip({ToolTipItem, top, width, left, bgColor, textColor} : ToolTipProps) {
  return (
    <div className={`absolute  ${top || '-top-8'} ${left || 'left-0'} ${width || 'w-max'} hidden group-hover:block ${bgColor || 'bg-black'} ${textColor || 'text-white'} text-xs px-3 py-1 rounded shadow-lg leading-5`}>
      {ToolTipItem}
    </div>
  );
}